import { useId } from "react";
import styles from "./rawTextEditor.module.css";

import { Text } from "../text/text";

export const RawTextEditor = ({ value, setValue, label, rows = 8 }) => {
    const id = useId();

    return (
        <div className={styles.editor}>
            {
                label &&
                <Text as="label" variant="body" className={styles.textarea_label}  htmlFor={id} size={12}>{label}</Text>
            }
            <div className={styles.textarea_container}>
                <textarea
                    id={id}
                    className={styles.textarea}
                    onChange={e => setValue(e.target.value)}
                    value={value}
                    rows={rows}
                />
            </div>
        </div>
    );
}